import React from 'react';

import { FORMAT_ELEMENT_COMMAND, LexicalEditor } from 'lexical';
import { Theme, useTheme } from '@mui/material';

import { MenuItem } from '../../../../../MenuItem';
import { Typography } from '../../../../../Typography';
import { Icon } from '../../../../../Icon';
import { Box } from '../../../../../Box';

type ForamtTypeToBlockName = {
  left: string;
  center: string;
  right: string;
  justify: string;
};

export const formatTypeToBlockName: ForamtTypeToBlockName = {
  left: 'По левому краю',
  center: 'По центру',
  right: 'По правому краю',
  justify: 'По ширине',
};

export type FormatTypeKeys = keyof ForamtTypeToBlockName;

export const getFormatIcon = (
  format: string,
  theme: Theme,
  activeFormat?: FormatTypeKeys,
) => {
  const getColor = (item: string, activeItem?: string) =>
    item === activeItem ? 'original.brand.primary' : 'text.light.primary';

  switch (format) {
    case 'left':
      return (
        <Icon
          name="text_left_outline"
          color={getColor('left', activeFormat)}
          size="20"
        />
      );
    case 'center':
      return (
        <Icon
          name="text_center_outline"
          color={getColor('center', activeFormat)}
          size="20"
        />
      );
    case 'right':
      return (
        <Icon
          name="text_right_outline"
          color={getColor('right', activeFormat)}
          size="20"
        />
      );
    case 'justify':
      return (
        <Icon
          name="vkhrtek_justify_format"
          color={getColor('justify', activeFormat)}
          size="16"
        />
      );
    default:
      return (
        <Icon name="text_left_outline" color="text.light.primary" size="20" />
      );
  }
};

export const useFormatElement = (
  editor: LexicalEditor,
  alignFormat: FormatTypeKeys,
) => {
  const theme = useTheme();

  const handleFormat = (format: string) => () => {
    editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, format as FormatTypeKeys);
  };

  return [
    Object.entries(formatTypeToBlockName).map(([format, name]) => (
      <MenuItem onClick={handleFormat(format)} key={format}>
        <Box display="flex" alignItems="center" gap="8">
          {getFormatIcon(format, theme, alignFormat)}
          <Typography
            variant="body3"
            color={
              alignFormat === format
                ? 'original.brand.primary'
                : 'text.light.primary'
            }
          >
            {name}
          </Typography>
        </Box>
      </MenuItem>
    )),
    getFormatIcon(alignFormat, theme),
  ];
};
